export const CURRENT_VERSION_HASH = import.meta.env.VITE_APP_CURRENT_VERSION_HASH || 'git'
